function bannerInlineStyleBodyDescription(_ref) {
  var fontSize = _ref.design.fontSize,
      _ref$bodyDesign = _ref.bodyDesign,
      descriptionInheritFontSize = _ref$bodyDesign.descriptionInheritFontSize,
      descriptionFontSize = _ref$bodyDesign.descriptionFontSize,
      descriptionTextAlign = _ref.individualLayout.descriptionTextAlign,
      antiAdBlocker = _ref.customCss.antiAdBlocker,
      individualPrivacyOpen = _ref.individualPrivacyOpen;
  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-description",
    style: {
      lineHeight: 1.5,
      fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
      textAlign: individualPrivacyOpen ? descriptionTextAlign : undefined
    }
  };
}

export { bannerInlineStyleBodyDescription };